import { render, staticRenderFns } from "./links-modal___1.vue?vue&type=template&id=25c5b42f&scoped=true"
import script from "./links-modal___1.vue?vue&type=script&lang=js"
export * from "./links-modal___1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5b42f",
  null
  
)

export default component.exports